import { $http } from '@/utils';

/**
 * @namespace Service
 * @class Schema
 * @exports Service/Option/Schema
 * @description API Option Schema Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Schema {
	/**
	 * @static @name get
	 * @description get schema option
	 * @returns {Object} Promise a http response
	 */
	static get(name) {
		return $http.get(`option/schema/${name}`);
	}
}
